export function monthCompareCounts(report) {
  if (report == null || typeof report !== "object" || Array.isArray(report)) {
    return [0, 0];
  }
  const previous = Number(
    report.totalPlayerTillLastMonth
    ?? report.totalRevenueTillLastMonth
    ?? report.prev
    ?? 0
  );
  const current = Number(
    report.totalPlayerTillNow
    ?? report.totalRevenueTillNow
    ?? report.curr
    ?? 0
  );
  return [
    Number.isFinite(previous) ? previous : 0,
    Number.isFinite(current) ? current : 0,
  ];
}
